import profile from '../../Assets/Images/Artists/06/profile_hidden.jpg'

const text = `on a cold sunday afternoon,
in a coffee shop,
in the pages of a battered book
authored by political dissidents,
alice catches a glimpse of her muchness again.

a moment of clarity

she inhales

sentiments infused in the pages
seep into her lungs,
capillaries permeated
with the once familiar rush of desire
for naive revolution.
an overthrow of tyranny
and an outpouring of love.

the scene around her sharpens,
her place within the picture
defined
by a renewed belief
in something,
not quite something new,
but something better.
maybe just the possibility of something better.

the thought
envelops her a cloud of calm,
a quiet fire rekindled in her belly
that fills her fingertips with warmth
and her toes with dances.
unprompted
laughter pools in the corners of her eyes
and pulls at her cheekbones.

outside
clear skies hint at a promise of warmer days
and opportunity,
grass and dirt under bare feet,
tracing new paths
under the enduring sun.

maybe
it's just the caffeine rush

maybe that doesn’t matter

inside the coffee shop
alice begins to fall in love with life again.`

const project1 = {
  title: 'revival',
  year: 2017,
  content: [
    {
      type: 'text',
      writting: [
        {
          title: 'revival',
          text: text
        }
      ]
    }
  ]
}

const projects = [
  project1,
]

const user = {
  username: 'dwrds',
  name: undefined,
  url: undefined,
  avatar: profile,
  seen: false,
  anonymous: true,
  projects: projects
}

export default user



// WEBPACK FOOTER //
// ./src/Data/Users/dwrds.js